import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeNumeric extends TraitRegistryItem {
    constructor(init = {}) {
        super(init);
        Object.assign(this, init);
    }
    step = 1;
    min = 0;
    max = 100;
    roundDecimals = 2;
    default = 0;
    onEditChange;
}
